import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GamepadDirectional,
  UserRound,
  Globe,
  X,
  Gift,
  Percent,
  House,
  Crown,
  BadgePercent,
  HandCoins,
  Users,
  Headset,
  Trophy,
  FileText,
  Languages,
} from "lucide-react";
import "./Header.css";
import LoginModal from "../LoginModal/LoginModal";
import Logo from "../../common/Logo";
import LanguageModal from "../LanguageModal";
import useTranslate from "../../hooks/useTranslate";
import { setCurrentLanguage } from "../../i18n";
const LANGUAGE_LABELS = {
  en: "English",
  bn: "Bangladeshi",
};

export default function Header() {
  const navigate = useNavigate();
  const { t, lang } = useTranslate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [open, setOpen] = useState(false);


  useEffect(() => {
    const checkLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    };

    checkLogin();

    window.addEventListener("storage", checkLogin);
    window.addEventListener("auth-changed", checkLogin);

    return () => {
      window.removeEventListener("storage", checkLogin);
      window.removeEventListener("auth-changed", checkLogin);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("site_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);



  const currentLanguageLabel = useMemo(() => {
    return LANGUAGE_LABELS[lang] || "English";
  }, [lang]);

  const quickActions = [
    { label: t("rewards"), icon: Gift, path: "/reward-page", isLogin: true },
    { label: t("promotions"), icon: Percent, path: "/promotions" },
  ];
  
  const menuItems = [
    { label: t("home"), icon: House, path: "/home" },
    { label: t("vip"), icon: Crown, path: "/vip-bonus", isLogin: true },
    { label: t("promotion"), icon: BadgePercent, path: "/promotions" },
    { label: t("freePromo"), icon: Gift, path: "/promo_free", isLogin: true },
    { label: t("affiliate"), icon: HandCoins, path: "/affiliate", isLogin: true },
    { label: t("myAccount"), icon: UserRound, path: "/profile", isLogin: true },
    { label: t("aboutUs"), icon: Users, path: "/about-us" },
    { label: t("contactUs"), icon: Headset, path: "/contact-us" },
    { label: t("liveMatch"), icon: Trophy, path: "/live-match", isLogin: true },
    { label: t("rewards"), icon: Gift, path: "/reward-page", isLogin: true },
    { label: t("termsConditions"), icon: FileText, path: "/terms" },
    { label: t("regionLanguage"), icon: Languages, path: "/language" },
  ];

  const handleMenuNavigate = (item) => {
    if (item.path === "/language") {
      setOpen(true);
      setShowMenu(false);
      return;
    }

    if (item.isLogin) {
      if (isLoggedIn) {
        navigate(item.path);
      } else {
        setShowModal(true);
      }
    } else {
      navigate(item.path);
    }

    setShowMenu(false);
  };

  return (
    <>
      <header className="site-header">
        <button
          className="nav-box"
          type="button"
          aria-label="Open menu"
          onClick={() => setShowMenu(true)}
        >
          <GamepadDirectional className="header-icon" strokeWidth={2.2} />
        </button>

        <div className="header-center">
          <a href="/" className="logo-link" aria-label="Go to home">
            <Logo width={41} height={41} />
          </a>
        </div>

        <div className="header-actions">
          {isLoggedIn ? (
            <img
              onClick={() => navigate("/profile")}
              width={29}
              src="../../images/42.jpeg"
              alt="Profile"
              style={{ cursor: "pointer" }}
            />
          ) : (
            <button
              onClick={() => setShowModal(true)}
              className="circle-action"
              type="button"
              aria-label="User account"
            >
              <UserRound className="header-icon" strokeWidth={2.2} />
            </button>
          )}

          <button
            className="circle-action"
            type="button"
            aria-label="Change language"
            onClick={() => setOpen(true)}
            title={currentLanguageLabel}
          >
            <Globe className="header-icon" strokeWidth={2.2} />
          </button>
        </div>
      </header>

      <div
        className={`side-menu-backdrop ${showMenu ? "show" : ""}`}
        onClick={() => setShowMenu(false)}
      />

      <aside className={`side-menu-drawer ${showMenu ? "open" : ""}`}>
        <div className="side-menu-inner">
          <button
            className="side-menu-close-box"
            type="button"
            onClick={() => setShowMenu(false)}
            aria-label="Close menu"
          >
            <X size={24} strokeWidth={2.6} />
          </button>

          <div className="side-menu-quick-grid">
            {quickActions.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.label}
                  type="button"
                  className="side-menu-quick-card"
                  onClick={() => handleMenuNavigate(item)}
                >
                  <Icon size={26} strokeWidth={2.4} />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </div>

          <div className="side-menu-divider" />

          <div className="side-menu-list">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.label}
                  type="button"
                  className="side-menu-item"
                  onClick={() => handleMenuNavigate(item)}
                >
                  <Icon
                    className="side-menu-item-icon"
                    size={30}
                    strokeWidth={2.2}
                  />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </aside>

      <LoginModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onLogin={(data) => console.log("login data:", data)}
        onRegister={() => console.log("register")}
        onForgotPassword={() => console.log("forgot password")}
      />

      <LanguageModal
        isOpen={open}
        onClose={() => setOpen(false)}
        selectedLanguage={lang}
  onSelectLanguage={(selected) => {
    setCurrentLanguage(selected);
    setOpen(false);
  }}
       
      />
    </>
  );
}